// Built on admin/global.js and  user/global.js

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

import './global/pnotify';
import './custom-console';

import WebFont from 'webfontloader';

window.WebFont = WebFont;
